import {CrimeArea} from '@/components/crime/crimePanel';

/**
 * The crime profile of the neighbourhood of a place: the settlement unit the place lies in as the
 * crime map describes it, or null where the statistics have nothing. Served on every domain, so
 * the pages and forms of any module ask the same way. Rejects where the request fails.
 */
export function loadCrimeProfile(latitude: number, longitude: number): Promise<CrimeArea | null> {
    const queryParameters = new URLSearchParams({latitude: String(latitude), longitude: String(longitude)});

    return fetch(`/api/crime-profile?${queryParameters.toString()}`)
        .then(response => {
            if (!response.ok) {
                throw new Error(`The crime profile could not be loaded (${response.status}).`);
            }
            return response.json() as Promise<CrimeArea | null>;
        });
}
